import NavigationMenu from './lib/NavigationMenu';

export default NavigationMenu;
